<template>
    <div class="dashContent">
        <banet-modal-confirm
                @confirmNo="confirmDelete(false)"
                @confirmYes="confirmDelete(true)"
                :show="confirmDialog.show"
                :showFooter="true"
                :title="confirmDialog.title"
                :body="confirmDialog.body">
        </banet-modal-confirm>
        <banet-modal-info
                @infoClose="infoDialog.show = false"
                :show="infoDialog.show"
                :showFooter="true"
                :title="infoDialog.title"
                :body="infoDialog.body">
        </banet-modal-info>
        <div class="panel-heading componentHeader">
            <div class="col-sm-2">
                <h2>{{ getTranslation('lbl_panel_headline_timeplan') }}</h2>
            </div>
            <div  class="col-sm-8 text-center">
                <div class="center-block">
                    <strong>{{ getTranslation('lbl_ticket_filter') }}:</strong>
                    <el-select v-model="periodFilter">
                        <el-option
                                v-for="option in periodFilterOptions"
                                :label="option.label"
                                :key="option.val"
                                :value="option.val">
                        </el-option>
                    </el-select>
                    <banet-pagination :count="count" @pagingEvent="setPage"></banet-pagination>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="pull-right">
                    <button  v-if="!shouldShowAddNew"
                            class="btn btn-default"
                            @click="showAddNew"
                            :disabled="!clientExists">{{ getTranslation('btn_add_timeplan') }}
                    </button>
                    <router-link :to="'/history/timeplan/all/' + clientId"
                                          tag="button"
                                          class="btn btn-primary"
                                          :title="getTranslation('lbl_history')">
                    <i class="fa fa-history" aria-hidden="true"></i></router-link>
                </div>
            </div>
        </div>
        <div class="timeplan clearfix">
            <table class="table table-bordered table-striped">
                <thead>
                <tr>
                    <th>{{ getTranslation('lbl_timeplan_period_start_time') }}</th>
                    <th>{{ getTranslation('lbl_timeplan_period_end_time') }}</th>
                    <th>{{ getTranslation('lbl_timeplan_period_contact') }}</th>
                    <th>{{ getTranslation('lbl_grid_col_action') }}</th>
                </tr>
                </thead>
                <tbody v-if="!loadingTimeplan">
                <tr v-if="shouldShowAddNew" class="editable">
                    <td>
                        <banet-datetime-picker
                                :placeholder="getTranslation('lbl_timeplan_select_datetime')"
                                @input="selectDate('new', 'start', $event)"
                                ref="newDatePicker"></banet-datetime-picker>
                    </td>
                    <td>
                        <banet-datetime-picker
                                :placeholder="getTranslation('lbl_timeplan_select_datetime')"
                                @input="selectDate('new', 'end', $event)"
                                ref="newDatePicker"></banet-datetime-picker>
                    </td>
                    <td>
                        <el-select v-model="newPeriod.contact"
                                   :placeholder="getTranslation('lbl_timeplan_select_contact')"
                                   :no-data-text="getTranslation('lbl_timeplan_no_contacts')">
                            <el-option
                                    v-for="contact in contacts"
                                    :label="contact.name"
                                    :key="contact._id"
                                    :value="contact._id">
                            </el-option>
                        </el-select>
                    </td>
                    <td>
                        <button :title="getTranslation('lbl_save')"
                                class="btn btn-success"
                                @click="saveNewPeriod"><span class="fa fa-floppy-o"></span></button>
                        <button :title="getTranslation('lbl_cancel')"
                                class="btn"
                                @click="hideAddNew"><span class="fa fa-ban"></span></button>
                    </td>
                </tr>
                <tr v-if="timeplan && timeplan.length" v-for="(period, index) in timeplan">
                    <td style="width: 310px; white-space:nowrap;">
                        <template v-if="showEditID != period._id">
                            {{ getFormattedDateString(period.startdate) }}
                        </template>
                        <template v-else>
                            <banet-datetime-picker
                                    :placeholder="getTranslation('lbl_timeplan_select_datetime')"
                                    @input="selectDate('edit', 'start', $event)"
                                    :value="editPeriod.startdate"></banet-datetime-picker>
                        </template>
                    </td>
                    <td style="width: 310px; white-space:nowrap;" >
                        <template v-if="showEditID != period._id" >
                           <span :class="{ongoing: !period.enddate}"> {{getFormattedDateString(period.enddate) }}</span>
                        </template>
                        <template v-else>
                            <banet-datetime-picker
                                    :placeholder="getTranslation('lbl_timeplan_select_datetime')"
                                    @input="selectDate('edit', 'end', $event)"
                                    :value="editPeriod.enddate"></banet-datetime-picker>
                        </template>
                    </td>
                    <td>
                        <template v-if="showEditID != period._id">
                            <span :class="[period.contact && !period.contact.deleted ? '' : 'noContact']">
                                {{ (period.contact && !period.contact.deleted) ? period.contact.name :
                                    getTranslation('lbl_no_contact_for_timeline_period')}}
                            </span>
                        </template>
                        <template v-else>
                            <el-select v-model="editPeriod.contact"
                                       :placeholder="getTranslation('lbl_timeplan_select_contact')"
                                       :no-data-text="getTranslation('lbl_timeplan_no_contacts')">
                                <el-option
                                        v-for="contact in contacts"
                                        :label="contact.name"
                                        :key="contact._id"
                                        :value="contact._id">
                                </el-option>
                            </el-select>
                        </template>
                    </td>
                    <td> <!-- class="text-center"> -->
                        <template v-if="showEditID != period._id">
                            <button :title="getTranslation('lbl_edit')"
                                    class="btn btn-default"
                                    @click="showEdit(period._id, $event)"><span class="fa fa-pencil"></span></button>
                            <button v-if="period._id && period._id.indexOf('empty_id') < 0"
                                    :title="getTranslation('lbl_delete')"
                                    class="btn btn-danger"
                                    @click="shouldDeletePeriod(period._id)"><span class="fa fa-trash-o"></span></button>
                        </template>
                        <template v-else>
                            <button :title="getTranslation('lbl_save')"
                                    class="btn btn-success"
                                    @click="saveEditPeriod"><span class="fa fa-floppy-o"></span></button>
                            <button :title="getTranslation('lbl_cancel')"
                                    class="btn"
                                    @click="hideEdit(period._id)"><span class="fa fa-ban"></span></button>
                        </template>
                    </td>
                </tr>
                <tr v-if="!timeplan || !timeplan.length">
                    <td colspan="4">
                        <span  class="label">{{ getTranslation('lbl_no_data') }}</span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    /*
     Install package ElementUI

     npm install element-ui

     Import the following into the main js file:

     import ElementUI from 'element-ui';
     import enLocale from 'element-ui/lib/locale/lang/en';
     import locale from 'element-ui/lib/locale';

     and use them:

     Vue.use(ElementUI);
     locale.use(enLocale);

     Customized ElementUI CSS is located in src/assets/element-theme

     Change translationMixin with the one from the project
     */
    import { mainEventBus } from '../../../../main';
    import BanetModalConfirm from '../../../../Banet/errorsAndNotifications/BanetModalConfirm.vue';
    import BanetModalInfo from '../../../../Banet/errorsAndNotifications/BanetModalInfo.vue';
    import Datetimepicker from '../banet-datetime-picker/DateTimePicker.vue';
    import BanetPagination from '../../../../Banet/components/BanetPagination.vue';

    import {translationMixin} from '../../../../Banet/mixins/translationMixin';

    export default {
       mixins: [
          translationMixin
       ],
       props: [
          'client'
       ],
       sockets: {
          timeplan_err_no_endate_no_contact: function(){
             mainEventBus.$emit( 'alert', { type:'error', msg: 'timeplan_err_no_endate_no_contact' } );
          },
          timeplanChanged: function () {
              console.log('timeplanChanged');
             this.getTimeplan();
          },
          timeplanUpdated: function () {
              console.log('timeplanUpdated');
             this.getTimeplan();
          },
          contactChanged: function () {
              console.log('contactChanged');
             this.$socket.emit('getClientContact', this.client._id);
          },
          clientContactData: function (data) {
             if (data && data.length > 0) {
                this.noContactsAlert = false;
                this.contacts = data;
                let emptyContact = {
                   _id: null,
                   name: this.getTranslation('lbl_select_contact'),
                   position: 0
                };
                this.contacts.unshift(emptyContact);
                this.getTimeplan();
             } else {
                this.contacts = [];
                this.noContactsAlert = true;
             }
          }
       },
       data: function () {
          return {
             count: 10,
             page: 1,
             perpage: 10,
             timeplan: [],
             timeplanFilters: {actual:'actual', past:'past', all:'all'},
             periodFilter: '',
             periodFilterOptions: [],
             loadingTimeplan: false,
             shouldShowAddNew: false,
             showEditID: '',
             maxDate: 8640000000000000,
             newPeriod: {
                startdate: '',
                enddate: '',
                contact: '',
                client: this.client._id
             },
             editPeriod: {
                _id: '',
                startdate: '',
                enddate: '',
                contact: '',
                client: this.client._id,
                empty_id: null
             },
             contacts: [],
             confirmDialog: {
                show: false,
                title: '',
                body: ''
             },
             infoDialog: {
                show: false,
                title: '',
                body: ''
             },
             toDeleteId: '',
             clientId: '',
             noContactsAlert: true
          }
       },
       computed: {
          clientExists: function () {
             return (typeof this.client !== 'undefined' && typeof this.client._id !== 'undefined');
          },
          noContact(){
             let noContactTag = "<span class='noContact'>" +
                this.getTranslation('lbl_no_contact_for_timeline_period') + "</span>";
             return noContactTag;
          }
       },
       watch: {
          client: function () {
             if (this.clientExists && this.$socket) {
//                this.$socket.emit('getTimeplan', this.client._id);
                this.getTimeplan();
                this.$socket.emit('getClientContact', this.client._id);
                this.loadingTimeplan = true;
             }
          },
          periodFilter(){
             this.page = 1;
             this.getTimeplan();
          }
       },
       created: function () {
          this.clientId = this.client._id;
          this.$socket.emit('getClientContact', this.client._id);
          this.getTimeplan(true);
          this.periodFilter = this.getTranslation('lbl_timeplan_filter_actual');
          this.periodFilterOptions = [];
          this.periodFilterOptions.push({
             label: this.getTranslation('lbl_timeplan_filter_actual'),
             val: this.timeplanFilters['actual']
          });
          this.periodFilterOptions.push({
             label: this.getTranslation('lbl_timeplan_filter_past'),
             val: this.timeplanFilters['past']
          });
          this.periodFilterOptions.push({
             label: this.getTranslation('lbl_timeplan_filter_all'),
             val: this.timeplanFilters['all']
          });
       },
       components: {
          'banet-modal-confirm': BanetModalConfirm,
          'banet-modal-info': BanetModalInfo,
          'banet-datetime-picker': Datetimepicker,
          'banet-pagination': BanetPagination
       },
       methods: {
          setPage(pageData){
             this.page = pageData.page;
             this.perpage = pageData.perpage;
             this.getTimeplan();
          },
          selectDate: function(pickerType, dateType, event) {
             if(!event) { event = ''; }
              this[pickerType + 'Period'][dateType + 'date'] = (event != '') ? this.getDateString(event) : '';
          },
          saveNewPeriod(){
             if(this.noContactsAlert){
                mainEventBus.$emit( 'alert', { type:'warning', msg: 'timeplan_warn_no_contact' } );
                return;
             }
              if (!this.newPeriod.enddate && !this.newPeriod.contact) {
                  mainEventBus.$emit( 'alert', { type:'error', msg: 'timeplan_err_no_endate_no_contact' } );
                  return;
              }
              if (new Date(this.newPeriod.startdate).getTime() > new Date(this.newPeriod.enddate).getTime()) {
                  mainEventBus.$emit( 'alert', { type:'warning', msg: 'lbl_timeplan_startdate_after' } );
                  return;
              }

             this.$http.post('timeplan/save/create', this.newPeriod).then(res=>{
                 this.$socket.emit('timeplanRefresh');
                mainEventBus.$emit( 'alert', { type:'info', msg: res.body.title } );
                this.getTimeplan(true);
                this.hideAddNew();
                this.resetEditPeriod();
             }, res=>{
                mainEventBus.$emit( 'alert', { type:'warning', msg: res.body.title } );
//                this.resetEditPeriod();
             });
          },
          saveEditPeriod(){
              if (new Date(this.editPeriod.startdate).getTime() > new Date(this.editPeriod.enddate).getTime()) {
                  mainEventBus.$emit( 'alert', { type:'warning', msg: 'lbl_timeplan_startdate_after' } );
                  return;
              }

             if(this.editPeriod.empty_id || !this.editPeriod._id) {
                this.newPeriod = {
                    startdate: this.editPeriod.startdate,
                    enddate: this.editPeriod.enddate,
                    contact: this.editPeriod.contact,
                    client: this.client._id
                };
                this.saveNewPeriod();
                return;
             }
             if(this.editPeriod._id && !this.editPeriod.contact) {
                // to delete
                //this.removeContact(this.editPeriod._id);
                 this.toDeleteId = this.editPeriod._id;
                 this.deletePeriod('msg_timeplan_updated');
                 return;
             }
             this.$http.post('timeplan/save/update', this.editPeriod).then(function(res){
                this.$socket.emit('timeplanRefresh');
                mainEventBus.$emit( 'alert', { type:'info', msg: res.body.title } );
                this.getTimeplan(true);
                this.resetEditPeriod();
             }, res=>{
                mainEventBus.$emit( 'alert', { type:'warning', msg: res.body.title } );
             });
          },
          shouldDeletePeriod: function(id) {
             this.toDeleteId = id;
             this.showDialog('confirmDialog', this.getTranslation('modal_confirm_title'), this.getTranslation('lbl_timeplan_delete_item'));
          },
          deletePeriod(message){
             this.$http.post('timeplan/save/delete', {_id: this.toDeleteId}).then(res=>{
                 mainEventBus.$emit('alert', {type: 'info', msg: message ? message: res.body.title});
                 this.$socket.emit('timeplanRefresh');
                this.getTimeplan(true);
                this.resetEditPeriod();
             }, res=>{
                  mainEventBus.$emit( 'alert', { type:'warning', msg: res.body.title } );
             });
          },
          getTimeplan(n){
             let filter = (this.periodFilter === this.getTranslation('lbl_timeplan_filter_actual')) ?
             this.timeplanFilters['actual'] : this.periodFilter;
             this.$http.get('timeplan', { params: {client: this.client._id, filter: filter, perpage:
             this.perpage, page: this.page}})
                .then(res=>{
                    if(n && typeof res.data.obj === 'undefined'){
                       this.getTimeplan();
                       return;
                    }
                    this.hideEdit();
                    this.hideAddNew();
                    this.timeplan = res.data.obj;
                    this.count = res.data.count;
                });
          },
          pad: function(number) {
             if (parseInt(number) < 10)
                return '0' + number;
             else
                return number;
          },
          showAddNew: function() {
             this.hideEdit();
             this.shouldShowAddNew = true;
             this.newPeriod.startdate = '';
             this.newPeriod.enddate = '';
             this.newPeriod.contact = this.contacts.length ? this.contacts[0]._id : '';
          },
          hideAddNew: function() {
             this.shouldShowAddNew = false;
          },
          showEdit: function(id, event) {
             this.resetEditPeriod();
             this.hideAddNew();
             this.showEditID = id;
             let period = this.findById(this.timeplan, id, 'value');
             if(period.empty_id){
                this.editPeriod.empty_id = period.empty_id;
             }
             this.editPeriod._id = period._id;
             this.editPeriod.startdate = period.startdate;
             this.editPeriod.enddate = (period.enddate) ? period.enddate : '';
             if (typeof period.contact === 'undefined' || period.contact == null) {
                this.editPeriod.contact = (this.contacts.length) ? this.contacts[0]._id : '';
             } else if (period.contact.deleted) {
                this.editPeriod.contact = '';
             } else {
                this.editPeriod.contact = period.contact._id;
             }
          },
          hideEdit: function() {
             this.showEditID = '';
          },
          resetEditPeriod(){
             this.editPeriod = {
                _id: '',
                startdate: '',
                enddate: '',
                contact: '',
                client: this.client._id
             };
             this. newPeriod = {
                startdate: '',
                enddate: '',
                contact: '',
                client: this.client._id
             };
             this.toDeleteId = '';
          },
          showDialog: function(dialogType, title, body) {
             this[dialogType].title = title;
             this[dialogType].body = body;
             this[dialogType].show = true;
          },
          confirmDelete: function(shouldDelete) {
             if (shouldDelete) {
                this.deletePeriod();
             } else {
                this.toDeleteId = '';
             }
             this.confirmDialog.show = false;
          },
          findById: function(array, id, whatToFind) {
             if (typeof whatToFind === 'undefined')
                whatToFind = 'value';

             if (whatToFind == 'value')
                return array.find(function(element) {
                   return element._id == id;
                });
             else if (whatToFind == 'index')
                return array.findIndex(function(element) {
                   return element._id == id;
                });
             else
                return null;
          },
           getDateString: function(date) {
             if (typeof date === 'undefined') {
                 date = new Date();
             }
             else {
                 date = new Date(date);
             }

             var formattedDate = date.getUTCFullYear() + '-';
             formattedDate += this.pad(date.getUTCMonth() + 1) + '-';
             formattedDate += this.pad(date.getUTCDate()) + 'T';
             formattedDate += this.pad(date.getUTCHours()) + ':';
             formattedDate += this.pad(date.getUTCMinutes()) + ':';
             formattedDate += '00.000Z';

             return formattedDate;
          },
          getFormattedDateString: function(date) {
             date = date || this.getDateString(this.maxDate);

             if (date != this.getDateString(this.maxDate)) {
                var dateString = new Date(date);
                var formattedDate = dateString.getFullYear() + '-';
                formattedDate += this.pad(dateString.getMonth() + 1) + '-';
                formattedDate += this.pad(dateString.getDate()) + 'T';
                formattedDate += this.pad(dateString.getHours()) + ':';
                formattedDate += this.pad(dateString.getMinutes());
                var dateTime = formattedDate.split('T');
                var date = dateTime[0].split('-');
                var time = dateTime[1].split(':');
                return date[2] + '.' + date[1] + '.' + date[0] + ' ' + time[0] + ':' + time[1];
             } else {
                 return String.fromCharCode(0x221E); //'ongoing';
             }
          }
       }
    }
</script>

<style>

    .timeplan .period-filter .el-select {
        margin-left: 15px;
    }

    .timeplan .table tr > td:last-child {
        width: 1px;
        white-space: nowrap;
    }

    .timeplan tr.old-period {
        background-color: #f9f9f9;
    }

    .el-select-dropdown__item {
        padding: 2px 20px;
        height: 24px;
    }

    .el-time-panel__content::after, .el-time-panel__content::before {
        margin-top: -8px !important;
    }

    .banet-datetime-picker .input-button {
        height: 25px !important;
    }

    .date-separator {
        display: inline-block;
        margin: 0 5px;
    }

    .flatpickr-calendar.hasTime .flatpickr-time {
        height: 40px;
        border-top: 1px solid #e6e6e6;
    }
</style>


// WEBPACK FOOTER //
// Timeplan.vue?1e53f463